import React from 'react';
import { DateInputRecord } from 'types/dynamic-forms/records/DateInputRecord';
import { useIsAdmin } from 'hooks/useRoleCheck';
import usePropertyPath from '../hooks/usePropertyPath';
import useProperty from '../hooks/useProperty';
import { useDocumentStore } from '../hooks/useDocumentStore';
import WizardDateOnlyPicker from 'components/v2/epd-wizard-inputs/WizardDateOnlyPicker';

const DateInputRenderer: React.FC<DateInputRecord> = ({
  propertyId,
  label,
  tooltip,
  readOnly,
  maxValueType,
  minValueType,
  visibleInStatuses,
  visibleInAllStatusesForAdmin,
}) => {
  const propertyPath = usePropertyPath(propertyId);
  const { value, setValue, isVisible, isDisabled, errorMessage } = useProperty<string | null>(propertyPath);
  const {
    metadata: { documentStatus },
  } = useDocumentStore();
  const isAdmin = useIsAdmin();
  if (!isVisible) {
    return null;
  }
  // While the field is read-only (its area is not editable in the current state) restrict it to the
  // listed statuses. While editable (e.g. an admin entering the dates before publication) it stays shown.
  // With visibleInAllStatusesForAdmin, Super Admin sees it in every status; the list applies to other roles.
  if (
    visibleInStatuses &&
    isDisabled &&
    !(visibleInAllStatusesForAdmin && isAdmin) &&
    !visibleInStatuses.includes(documentStatus)
  ) {
    return null;
  }

  return (
    <WizardDateOnlyPicker
      label={label}
      tooltip={tooltip}
      placeholder="Select"
      name={propertyId}
      defaultValue={value}
      error={errorMessage}
      maxValueType={maxValueType}
      minValueType={minValueType}
      onChanged={(_, value) => setValue(value)}
      disabled={isDisabled || readOnly}
    />
  );
};

export default DateInputRenderer;
